<template>
	<div class="mt-n5">
		<v-card class="sidebar">
			<v-list class="sidebar-list">
				<v-list-item
					v-for="link in prettyAppBaseMenu"
					:key="link.id"
					class="sidebar-list__item"
					:ripple="false"
				>
					<v-list-item-content class="sidebar-list__content">
						<router-link
							active-class="active"
							:to="link.route"
							exact
							class="text-decoration-none"
							@click.native="handleMenuClick(link)"
						>
							<v-list-item-title class="sidebar-list__title text-wrap">
								<Icon
									v-if="link.icon"
									class="sidebar-list__title icon-class"
									:size="16"
									:type="link.icon"
									:color="
										isActiveLink(link)
											? 'var(--accent-color)'
											: 'var(--accent-color)'
									"
								/>
								{{ link.title }}
							</v-list-item-title>
						</router-link>
					</v-list-item-content>
				</v-list-item>
				<v-list-item
					v-for="webViewlink in prettyAppWebViewMenu"
					:key="webViewlink.id"
					class="sidebar-list__item"
				>
					<v-list-item-content class="sidebar-list__content">
						<a
							:href="webViewlink.route"
							target="_blank"
							class="text-decoration-none"
							@click="handleMenuClick(webViewlink)"
						>
							<v-list-item-title class="sidebar-list__title text-wrap">
								<Icon
									style="margin-left: -2px"
									v-if="webViewlink.icon"
									:type="webViewlink.icon"
									class="icon-class"
									:size="22"
									color="var(--accent-color)"
								/>
								{{ webViewlink.title }}
							</v-list-item-title>
						</a>
					</v-list-item-content>
				</v-list-item>
			</v-list>
		</v-card>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import plusIcon from '@/assets/images/icon-plus.svg'
import Dwh from '@/mixins/Dwh'

export default {
	name: 'AppSidebar',
	mixins: [Dwh],
	watch: {
		selectedTags: {
			handler(val) {
				this.$eventBus.$emit('selected-tags', val)
			},
		},
	},
	props: {
		menuListHandler: {
			type: Function,
			default: () => {},
		},
	},
	data() {
		return {
			plusIcon: plusIcon,
			triggerMenuNames: [
				{ name: 'threads', action: 'menu_news_feed' },
				{ name: 'events', action: 'menu_events' },
				{ name: 'resources', action: 'menu_resources' },
				{ name: 'events', action: 'menu_events' },
				{ name: 'users', action: 'menu_users' },
				{ name: 'forums', action: 'menu_forums' },
				{ name: 'rss-feed', action: 'menu_rss_feed' },
				{ name: 'directory', action: 'menu_directory' },
			],
		}
	},
	computed: {
		...mapGetters('user', ['popularAuthors', 'isPopularAuthorsLoading']),
		...mapGetters('settings', ['appCore']),
		...mapGetters('auth', ['profile']),
		userChapters() {
			return this.profile.chapters.filter((chapter) => !chapter.hidden_subgroup)
		},
		userIsMember() {
			return this.profile.is_member
		},
		prettyAppBaseMenu() {
			if (!this.appCore) {
				return []
			}
			return this.appCore.appMenuNormalized.baseMenuItems
				.filter((item) => {
					if (!item.title || !item.route) {
						return false
					}
					if (item.chapters && item.chapters.length) {
						let result = false
						item.chapters.forEach((chapter) => {
							if (
								this.userChapters.some(
									(userChapter) => userChapter.chapter_id === chapter
								)
							) {
								result = true
							}
						})
						if (!result) {
							return false
						}
					}
					if (item.role === null || (item.block && item.block === 2)) {
						return true
					} else if (
						(item.role && this.userIsMember) ||
						(!item.role && !this.userIsMember)
					) {
						return true
					}
					return false
				})
				.map((item) => {
					return item
				})
		},
		prettyAppWebViewMenu() {
			if (!this.appCore) {
				return []
			}
			return this.appCore.appMenuNormalized.webViewMenuItems
				.filter((item) => {
					if (!item.title || !item.route || !item.id) {
						return false
					}
					if (item.chapters && item.chapters.length) {
						let result = false
						item.chapters.forEach((chapter) => {
							if (
								this.userChapters.some(
									(userChapter) => userChapter.chapter_id === chapter
								)
							) {
								result = true
							}
						})
						if (!result) {
							return false
						}
					}
					if (item.role === null || (item.block && item.block === 2)) {
						return true
					} else if (
						(item.role && this.userIsMember) ||
						(!item.role && !this.userIsMember)
					) {
						return true
					}
					return false
				})
				.map((item) => {
					return item
				})
		},
	},
	methods: {
		...mapActions('user', ['fetchPopularAuthors']),
		isActiveLink(link) {
			const targetRoute = this.$router.resolve(link.route).route
			return targetRoute.fullPath === this.$route.fullPath
		},

		handleMenuClick(link) {
			const trigger = this.triggerMenuNames.find(
				(trigger) => trigger.name === link.route.name
			)
			if (trigger) {
				this.sendTrigger({
					category: 'Navigation',
					action: trigger.action,
					module: 'Menu',
					title: link.title,
					content_chapter_id: link.chapters,
				})
			} else if (link.route.startsWith('http')) {
				this.sendTrigger({
					category: 'Navigation',
					action: 'menu_web_view',
					module: 'Menu',
					title: link.title,
					content_chapter_id: link.chapters,
				})
			}
		},
	},
}
</script>

<style lang="scss">
.active {
	text-decoration: none;

	> div {
		font-size: 15px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
		line-height: 20px;
	}
}

.sidebar {
	max-width: 250px;
	width: 100%;
	background-color: unset !important;
	border-radius: 10px !important;
	box-shadow: none !important;
}

.sidebar-list {
	padding: 26px 30px 6px 30px;
	background-color: unset !important;

	&__item {
		font-size: 10px !important;
		font-family: Montserrat, sans-serif;
		font-weight: 500;
		line-height: 20px;
		padding: 0;
		min-height: 38px;
		display: flex;
		align-items: center;
	}

	&__content {
		padding: 0 0 20px 0;
		display: flex;
		align-items: center;
	}

	&__title {
		font-size: 14px;
		font-family: Montserrat, sans-serif;
		font-weight: 500;
		line-height: 20px;
		color: var(--accent-color) !important;
		display: flex;
		align-items: center;
	}

	.icon-class {
		width: 20px !important;
		height: 16px !important;
		margin-right: 8px;
		position: absolute;
		left: -24px;
	}
}

.create-post {
	&__submit {
		width: 250px;
		height: 54px;
		margin-top: 30px;
		background: rgb(65, 161, 216) !important;
		border-radius: 10px;
		text-transform: capitalize !important;
		color: rgb(255, 255, 255) !important;
		font-size: 16px !important;
		font-family: Montserrat, sans-serif !important;
		font-weight: bold;
		align-items: center;
	}
}
</style>
